import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=380d0b62&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=380d0b62&prod&scoped=true&lang=css"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=380d0b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d0b62",
  null
  
)

export default component.exports